<template>
    <div>
        <!-- 月度账务分析 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="24" class="title">月度账务分析</Col>
                    </Row>
                    <!-- 年度每月花费 -->
                    <Row>
                        <Col span="24" style="height: 100%;">
		                    <div id="annualMonthlyExpenses" style="height: 400px;"></div>
		                </Col>
                    </Row>
                    <Row style="margin-bottom: 16px;">
                        <Col span="24" style="font-size: 13px;margin-bottom: 5px;margin-top: 5px;">从上图可以看到总体费用（这里的金额单位都是人民币）相对{{billRelativeMonthStr}}月份账单{{billCompareResult}}{{billCompareResultRatio}}%</Col>
                    </Row>
                    <Row :gutter="4" style="margin-bottom: 16px;">
                    	<Col span="20" style="font-size: 13px;margin-bottom: 5px;">填写原因</Col>
                        <Col span="24">
                            <Input v-model="description" type="textarea" :autosize="{minRows: 2,maxRows: 5}" style="margin-bottom: 10px;"></Input>
                        </Col>
                        <Col span="24">
                            <Button @click="renew" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:update_billing_stats']">更新</Button>
                        </Col>
                    </Row>

                </Card>
            </Col>
        </Row>
        <!-- 预留实例推荐花费对比 -->
        <Row style="margin-bottom: 20px;">
            <Col span="24">
                <Card >
                    <Row>
                        <Col span="20" class="title">预留实例推荐花费对比</Col>
                        <Col style="float: right;">
                            <div @click="selectCostComparison()">
                                <Button @click="costComparisonModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_RI_reccmd_contrast']">添加</Button>
                            </div>
                        </Col>
                    </Row>
                    <!-- 预留实例推荐花费对比 -->
                 	<Table :no-data-text="$t('common.noData')" class="table-css" height="470" :columns="costComparison" :data="costComparisonDate" :loading="costComparisonLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDelete(index)">
			                    <Button type="error" size="small" @click="costComparisonDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_RI_reccmd_contrast']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                 	<!-- 预留实例 -->
                 	<Row style="margin-bottom: 10px;margin-top: 10px;">
                        <Col span="20" style="font-size: 13px;margin-bottom: 5px;margin-top: 5px;">贵公司账户购买了{{reservedInstanceNumber}}台预留实例,经过后台检测,目前全部匹配,详情如下</Col>
                         <Col style="float: right;">
                            <div @click="selectReservedInstance()">
                                <Button @click="reservedInstanceModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:add_RI_instance']">添加</Button>
                            </div>
                        </Col>
                    </Row>
                    <Table :no-data-text="$t('common.noData')" class="table-css" height="470" :columns="reservedInstance" :data="reservedInstanceDate" :loading="reservedInstanceLoading">
                 		<template slot-scope="{row,index}" slot="delete">
			                <span @click="doDeleteReservedInstance(index)">
			                    <Button type="error" size="small" @click="reservedInstanceDelModal = true" v-hasPermission="['operationKpiConfigurationManagement:reportConfiguration:delete_RI_instance']">{{ $t('ticket.list.delete') }}</Button>
			                </span>
			            </template>
                 	</Table>
                </Card>
            </Col>
        </Row>
        <!-- 预留实例推荐花费对比添加 -->
        <Modal v-model="costComparisonModal" title="添加" width="1000px;" :loading="modalLoading" ok-text="添加" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancel()">取消</Button>
                <Button type="primary" @click="handleSubmit()" :loading="addloading" :disabled="isDisable">添加</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="columns" :loading="loading" :data="queryCostComparisonData" :height="400" @on-selection-change="getSelection"></Table>
        </Modal>
        <!-- 预留实例推荐花费对比删除 -->
        <Modal v-model="costComparisonDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }}{{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="modal_loading" @click="removeCostComparison()" :disabled="isDisableDelete">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
        <!--分割线-->
        <!-- 预留实例添加 -->
        <Modal v-model="reservedInstanceModal" title="添加" width="900px;" :loading="reservedInstanceModalLoading" ok-text="添加" :mask-closable="false" :closable="false">
            <div slot="footer">
                <Button @click="cancelReservedInstance()">取消</Button>
                <Button type="primary" @click="reservedInstanceHandleSubmit()" :loading="reservedInstanceAddloading" :disabled="reservedInstanceIsDisable">添加</Button>
            </div>
            <Table :no-data-text="$t('common.noData')" class="table-css" ref="selection" :columns="reservedInstanceColumns" :loading="reservedInstanceLoadingAdd" :data="queryReservedInstanceData" :height="400" @on-selection-change="getSelectionReservedInstance"></Table>
        </Modal>
        <!-- 预留实例删除 -->
        <Modal v-model="reservedInstanceDelModal" width="360" :mask-closable="false">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="ios-information-circle"></Icon>
                <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
            </p>
            <div style="text-align:center">
                <p>{{ $t('alarms.common.sureDelete') }}{{ $t('alarms.common.what') }}?</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="reservedInstanceDelLoading" @click="removeReservedInstance()" :disabled="isDisableReservedInstance">{{ $t('ticket.list.delete') }}</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    var financialOptimizationVue = {}
    export default {
        name: 'FinancialOptimization',
        data(){
            return {
                instanceTenancyList:["default","dedicated","host"],
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
                billRelativeMonthStr:'',
                billCompareResult:'',
                billCompareResultRatio:'',
                annualMonthlyExpenditure:[],
                xaxisData:[],
                chartAnnualMonthlyExpenses:'', // echarts实例
                description: '',
                //预留实例推荐花费对比 添加
                reservedInstanceNumber:'',
            	selection: [],
                costComparisonModal: false,
                modalLoading: true,
                loading: false,
                addloading:false,
                isDisable: true,
                columns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '账号ID',
                    key: 'accountIdString'
                },
                {
                    title: '账号名称',
                    key: 'accountName'
                },
                {
                    title: '账户组名称',
                    key: 'accountGroupName'
                },
                {
                    title: '租赁类型',
                    key: 'instanceTenancy'
                },
                {
                    title: '实例系统',
                    key: 'productDescription'
                },
                {
                    title: '实例类型',
                    key: 'instanceType'
                },
                {
                    title: '推荐购买RI(单位:台)',
                    key: 'unmatchCount'
                },
                {
                    title: '按需年度花费',
                    key: 'onDemandCost'
                },
                {
                    title: '无前期RI年度花费',
                    key: 'noUpfrontCost'
                },
                {
                    title: '部分前期RI年度花费',
                    key: 'partUpfrontCost'
                },
                {
                    title: '全部前期年度花费',
                    key: 'allUpfrontCost'
                }],
                newQueryCostComparison:[],
                //预留实例推荐花费对比 删除
                name:'',
                modal_loading: false,
                costComparisonDelModal:false,
                isDisableDelete: false,
                //预留实例推荐花费对比
            	costComparisonLoading:false,
                costComparison: [
                {
                    title: '账号ID',
                    key: 'accountIdString'
                },
                {
                    title: '账号名称',
                    key: 'accountName'
                },
                {
                    title: '账户组名称',
                    key: 'accountGroupName'
                },
                {
                    title: '租赁类型',
                    key: 'instanceTenancy'
                },
                {
                    title: '实例系统',
                    key: 'productDescription'
                },
                {
                    title: '实例类型',
                    key: 'instanceType'
                },
                {
                    title: '推荐购买RI(单位:台)',
                    key: 'unmatchCount'
                },
                {
                    title: '按需年度花费',
                    key: 'onDemandCost'
                },
                {
                    title: '无前期RI年度花费',
                    key: 'noUpfrontCost'
                },
                {
                    title: '部分前期RI年度花费',
                    key: 'partUpfrontCost'
                },
                {
                    title: '全部前期年度花费',
                    key: 'allUpfrontCost'
                },
                {
                	title:'操作',
                	slot:'delete'
                }],
                costComparisonDate:[],
                queryCostComparisonData: [],
                //预留实例 添加
            	selectionReservedInstance: [],
                reservedInstanceModal: false,
                reservedInstanceModalLoading: true,
                reservedInstanceLoadingAdd: false,
                reservedInstanceAddloading:false,
                reservedInstanceIsDisable: true,
                reservedInstanceColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '账号ID',
                    key: 'accountIdString'
                },
                {
                    title: '账号名称',
                    key: 'accountName'
                },
                {
                    title: '账户组名称',
                    key: 'accountGroupName'
                },
                {
                    title: '租赁类型',
                    key: 'instanceTenancy'
                },
                {
                    title: '实例系统',
                    key: 'productDescription'
                },
                {
                    title: '实例类型',
                    key: 'instanceType'
                },
                {
                    title: '总共购买RI(单位:台)',
                    key: 'reservedInstanceNumber'
                },
                {
                    title: '未匹配RI(单位:台)',
                    key: 'unmatchCount'
                }],
                newQueryReservedInstance:[],
                //预留实例 删除
                reservedInstanceName:'',
                reservedInstanceDelLoading: false,
                reservedInstanceDelModal:false,
                isDisableReservedInstance: false,
                //预留实例
            	reservedInstanceLoading:false,
                reservedInstance: [
                {
                    title: '账号ID',
                    key: 'accountIdString'
                },
                {
                    title: '账号名称',
                    key: 'accountName'
                },
                {
                    title: '账户组名称',
                    key: 'accountGroupName'
                },
                {
                    title: '租赁类型',
                    key: 'instanceTenancy'
                },
                {
                    title: '实例系统',
                    key: 'productDescription'
                },
                {
                    title: '实例类型',
                    key: 'instanceType'
                },
                {
                    title: '总共购买RI(单位:台)',
                    key: 'instanceCount'
                },
                {
                    title: '未匹配RI(单位:台)',
                    key: 'unmatchCount'
                },
                {
                	title:'操作',
                	slot:'delete'
                }],
                reservedInstanceDate:[],
                queryReservedInstanceData: []
            }
        },
        beforeCreate: function() {
            financialOptimizationVue = this
        },
        mounted () {
            financialOptimizationVue.queryById();
            financialOptimizationVue.listReportReservedInstances();
            financialOptimizationVue.listProdEnvironmentReservedInstance();
        	 // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartAnnualMonthlyExpenses.resize();
            });

        },
        created(){
            // 初始化参数
            this.accountIdList=JSON.parse(this.$route.query.accountIdList);
            this.reportId=Number(this.$route.query.reportId);
            this.companyId=Number(this.$route.query.companyId);
            this.reportDate=this.$route.query.reportDate;
            this.$nextTick(function() {
                financialOptimizationVue.getMonthlyBillingAnalysis();
            });
        },
        methods: {
            // 查询填写原因
            queryById:function(){
                this.$api.report.queryById("id",this.reportId)
                .then(res => {
                    this.description=res.data.billAnalysis;
                })
            },
            // 更新
            renew:function(){
                this.$api.report.updateBillAnalysis({
                    "id":this.reportId,
                    "billAnalysis":this.description
                })
                .then(res => {
                    this.$Message.success('更新成功!');
                })
            },
        	/*****************预留实例推荐花费对比*************************************/
        	// 表格
            listReportReservedInstances:function(){
                this.costComparisonLoading = true;
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.reportId,
                    "reportReservedInstanceType" : 0
                })
                .then(res => {
                    this.costComparisonDate = res.data;
                    for(var i=0;i<this.costComparisonDate.length;i++){
                        // 租赁类型
                        if(this.costComparisonDate[i].instanceTenancy==0){
                            this.costComparisonDate[i].instanceTenancy='default';
                        }else if(this.costComparisonDate[i].instanceTenancy==1){
                            this.costComparisonDate[i].instanceTenancy='dedicated';
                        }else if(this.costComparisonDate[i].instanceTenancy==2){
                            this.costComparisonDate[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.costComparisonDate[i].accountGroupName){
                            this.costComparison = this.costComparison.filter(col => col.key !== 'accountIdString' );
                            this.costComparison = this.costComparison.filter(col => col.key !== 'accountName' );
                        }else{
                            this.costComparison = this.costComparison.filter(col => col.key !== 'accountGroupName' );
                        }
                    }
                    this.costComparisonLoading = false;
                })
            },
            // 查询购买预留实例前后花费对比
            selectCostComparison:function(){
                this.loading=true;
                this.$api.reportReservedInstance.getReservedInstanceRecommendedCostComparisons({
                    "accountPrimaryKeyIds":this.accountIdList,
                    "reportId": this.reportId,
                    "companyId": this.companyId,
                    "monthStr": this.reportDate
                })
                .then(res => {
                    this.queryCostComparisonData = res.data.reportReservedInstanceDTOS;
                    for(var i=0;i<this.queryCostComparisonData.length;i++){
                        // 租赁类型
                        if(this.queryCostComparisonData[i].instanceTenancy==0){
                            this.queryCostComparisonData[i].instanceTenancy='default';
                        }else if(this.queryCostComparisonData[i].instanceTenancy==1){
                            this.queryCostComparisonData[i].instanceTenancy='dedicated';
                        }else if(this.queryCostComparisonData[i].instanceTenancy==2){
                            this.queryCostComparisonData[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.queryCostComparisonData[i].accountGroupName){
                            this.columns = this.columns.filter(col => col.key !== 'accountIdString' );
                            this.columns = this.columns.filter(col => col.key !== 'accountName' );
                        }else{
                            this.columns = this.columns.filter(col => col.key !== 'accountGroupName' );
                        }
                    }
                    this.loading = false;
                })
            },
            // 转换租赁类型
            getInstanceTenancy:function(instanceTenancyStr){
                for(var i=0;i<this.instanceTenancyList.length;i++){
                    if(instanceTenancyStr==this.instanceTenancyList[i]){
                        return i;
                    }
                }
                return -1;
            },
            // 当前选择checkbox
            getSelection: function (selection) {
                this.selection = selection;
                // 清空数组
                this.newQueryCostComparison = [];
                for (var i = 0; i < this.selection.length; i++) {
                    var instanceTenancy=this.getInstanceTenancy(this.selection[i].instanceTenancy);
                    var QueryCostComparisonDataCopy = new Object();
                    QueryCostComparisonDataCopy.reportId = this.selection[i].reportId;
                    QueryCostComparisonDataCopy.accountIdString = this.selection[i].accountIdString;
                    QueryCostComparisonDataCopy.accountName = this.selection[i].accountName;
                    QueryCostComparisonDataCopy.accountGroupName = this.selection[i].accountGroupName;
                    QueryCostComparisonDataCopy.instanceType = this.selection[i].instanceType;
                    QueryCostComparisonDataCopy.productDescription = this.selection[i].productDescription;
                    QueryCostComparisonDataCopy.instanceCount = this.selection[i].instanceCount;
                    QueryCostComparisonDataCopy.instanceTenancy = instanceTenancy;
                    QueryCostComparisonDataCopy.onDemandCost = this.selection[i].onDemandCost;
                    QueryCostComparisonDataCopy.noUpfrontCost = this.selection[i].noUpfrontCost;
                    QueryCostComparisonDataCopy.partUpfrontCost = this.selection[i].partUpfrontCost;
                    QueryCostComparisonDataCopy.allUpfrontCost = this.selection[i].allUpfrontCost;
                    QueryCostComparisonDataCopy.unmatchCount = this.selection[i].unmatchCount;
                    QueryCostComparisonDataCopy.type = 0;
                    QueryCostComparisonDataCopy.region = this.selection[i].region;
                    this.newQueryCostComparison.push(QueryCostComparisonDataCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryCostComparison.length == 0) {
                    this.isDisable = true;
                } else {
                    this.isDisable = false;
                }
            },
            // 添加
            handleSubmit: function () {
                this.addloading=true;
                this.$api.reportReservedInstance.createReportReservedInstance({
                    "reportId": this.reportId,
                    "reportReservedInstanceDTOS":this.newQueryCostComparison
                }).then(res => {
                    setTimeout(() => {
                        financialOptimizationVue.listReportReservedInstances();
                        this.modalLoading = false;
                        this.$nextTick(() => {
                            this.modalLoading = true;
                        });
                        this.$Message.success('添加成功');
                        this.queryCostComparisonData=[];
                        this.newQueryCostComparison=[];
                        this.costComparisonModal = false;
                        this.isDisable = true;
                        this.addloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancel: function () {
                this.isDisable = true;
                this.costComparisonModal = false;
                this.queryCostComparisonData=[];
                this.newQueryCostComparison=[];
            },
            // 删除
            /****************************************************/
            doDelete: function(index){
                this.lineIndex=index;
                this.name=this.costComparisonDate[index].name;
            },
            removeCostComparison: function(){
                this.isDisableDelete = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportReservedInstance.deleteReportReservedInstance("id",this.costComparisonDate[lineIndex].id)
                .then(res => {
                    this.modal_loading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        financialOptimizationVue.listReportReservedInstances();
                        this.isDisableDelete = false;
                        this.modal_loading = false;
                        this.costComparisonDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
            /*****************预留实例************************************************/
            // 表格
            listProdEnvironmentReservedInstance:function(){
                this.reservedInstanceLoading = true;
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.reportId,
                    "reportReservedInstanceType" : 1
                })
                .then(res => {
                    this.reservedInstanceDate = res.data;
                    for(var i=0;i<this.reservedInstanceDate.length;i++){
                        // 租赁类型
                        if(this.reservedInstanceDate[i].instanceTenancy==0){
                            this.reservedInstanceDate[i].instanceTenancy='default';
                        }else if(this.reservedInstanceDate[i].instanceTenancy==1){
                            this.reservedInstanceDate[i].instanceTenancy='dedicated';
                        }else if(this.reservedInstanceDate[i].instanceTenancy==2){
                            this.reservedInstanceDate[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.reservedInstanceDate[i].accountGroupName){
                            this.reservedInstance = this.reservedInstance.filter(col => col.key !== 'accountIdString' );
                            this.reservedInstance = this.reservedInstance.filter(col => col.key !== 'accountName' );
                        }else{
                            this.reservedInstance = this.reservedInstance.filter(col => col.key !== 'accountGroupName' );
                        }
                    }
                    this.reservedInstanceLoading = false;
                })
            },
            // 查询预留实例匹配结果
            selectReservedInstance:function(){
                this.reservedInstanceLoadingAdd=true;
                this.$api.reportReservedInstance.getReservedInstanceMatchingResult({
                    "accountPrimaryKeyIds":this.accountIdList,
                    "reportId": this.reportId,
                    "companyId": this.companyId,
                    "monthStr": this.reportDate
                })
                .then(res => {
                    this.queryReservedInstanceData = res.data.reportReservedInstanceDTOS;
                    // 预留实例总购买台数
                    this.reservedInstanceNumber=res.data.reservedInstanceNumber;
                    for(var i=0;i<this.queryReservedInstanceData.length;i++){
                        // 租赁类型
                        if(this.queryReservedInstanceData[i].instanceTenancy==0){
                            this.queryReservedInstanceData[i].instanceTenancy='default';
                        }else if(this.queryReservedInstanceData[i].instanceTenancy==1){
                            this.queryReservedInstanceData[i].instanceTenancy='dedicated';
                        }else if(this.queryReservedInstanceData[i].instanceTenancy==2){
                            this.queryReservedInstanceData[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.queryReservedInstanceData[i].accountGroupName){
                            this.reservedInstanceColumns = this.reservedInstanceColumns.filter(col => col.key !== 'accountIdString' );
                            this.reservedInstanceColumns = this.reservedInstanceColumns.filter(col => col.key !== 'accountName' );
                        }else{
                            this.reservedInstanceColumns = this.reservedInstanceColumns.filter(col => col.key !== 'accountGroupName' );
                        }
                    }
                    this.reservedInstanceLoadingAdd = false;
                })
            },
            // 当前选择checkbox
            getSelectionReservedInstance: function (selection) {
                this.selectionReservedInstance = selection;
                // 清空数组
                this.newQueryReservedInstance = [];
                for (var i = 0; i < this.selectionReservedInstance.length; i++) {
                    var instanceTenancy=this.getInstanceTenancy(this.selectionReservedInstance[i].instanceTenancy);
                    var QueryReservedInstanceCopy = new Object();
                    QueryReservedInstanceCopy.reportId = this.selectionReservedInstance[i].reportId;
                    QueryReservedInstanceCopy.accountIdString = this.selectionReservedInstance[i].accountIdString;
                    QueryReservedInstanceCopy.accountName = this.selectionReservedInstance[i].accountName;
                    QueryReservedInstanceCopy.accountGroupName = this.selectionReservedInstance[i].accountGroupName;
                    QueryReservedInstanceCopy.instanceTenancy = instanceTenancy;
                    QueryReservedInstanceCopy.productDescription = this.selectionReservedInstance[i].productDescription;
                    QueryReservedInstanceCopy.instanceType = this.selectionReservedInstance[i].instanceType;
                    QueryReservedInstanceCopy.unmatchCount = this.selectionReservedInstance[i].unmatchCount;
                    QueryReservedInstanceCopy.instanceCount = this.selectionReservedInstance[i].reservedInstanceNumber;
                    QueryReservedInstanceCopy.type = 1;
                    QueryReservedInstanceCopy.region = this.selectionReservedInstance[i].region;
                    this.newQueryReservedInstance.push(QueryReservedInstanceCopy);
                }

                // 选了数据 可以点击下一步
                if (this.newQueryReservedInstance.length == 0) {
                    this.reservedInstanceIsDisable = true;
                } else {
                    this.reservedInstanceIsDisable = false;
                }
            },
            // 添加
            reservedInstanceHandleSubmit: function () {
                this.reservedInstanceAddloading=true;
                this.$api.reportReservedInstance.createReportReservedInstance({
                    "reportId": this.reportId,
                    "reportReservedInstanceDTOS":this.newQueryReservedInstance
                }).then(res => {
                    setTimeout(() => {
                        financialOptimizationVue.listProdEnvironmentReservedInstance();
                        this.reservedInstanceModalLoading = false;
                        this.$nextTick(() => {
                            this.reservedInstanceModalLoading = true;
                        });
                        this.$Message.success('添加成功');
                        this.queryReservedInstanceData=[];
                        this.newQueryReservedInstance=[];
                        this.reservedInstanceModal = false;
                        this.reservedInstanceIsDisable = true;
                        this.reservedInstanceAddloading=false;
                    }, 1000);
                })
            },
             // 取消
            cancelReservedInstance: function () {
                this.reservedInstanceIsDisable = true;
                this.reservedInstanceModal = false;
                this.queryReservedInstanceData=[];
                this.newQueryReservedInstance=[];
            },
            // 删除
            /****************************************************/
            doDeleteReservedInstance: function(index){
                this.lineIndex=index;
                this.reservedInstanceName=this.reservedInstanceDate[index].name;
            },
            removeReservedInstance: function(){
                this.isDisableReservedInstance = true;  //开始可以点击
                var lineIndex=this.lineIndex;
                //删除
                this.$api.reportReservedInstance.deleteReportReservedInstance("id",this.reservedInstanceDate[lineIndex].id)
                .then(res => {
                    this.reservedInstanceDelLoading = true;
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if(lineIndex==0&&((this.current-1)*this.pageSize+1)==this.dataTotal){
                            this.current=this.current-1;
                        }
                        this.dataTotal=this.dataTotal-1;
                        financialOptimizationVue.listProdEnvironmentReservedInstance();
                        this.isDisableReservedInstance = false;
                        this.reservedInstanceDelLoading = false;
                        this.reservedInstanceDelModal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            },
        	/******************年度每月花费*******************************************************/
            init:function(){
                this.$nextTick(function() {
                    financialOptimizationVue.annualMonthlyExpensesLine();
                });
            },
            // 年度每月花费接口
            getMonthlyBillingAnalysis:function(){
                this.$api.reportReservedInstance.getMonthlyBillingAnalysis({
                    "accountPrimaryKeyIds":this.accountIdList,
                    "reportId": this.reportId,
                    "companyId": this.companyId,
                    "monthStr": this.reportDate
                })
                .then(res => {
                    // 相对月份
                    this.billRelativeMonthStr = res.data.billRelativeMonthStr;
                    // 花费0-上升， 1-下降
                    this.billCompareResult = res.data.billCompareResult;
                    if(this.billCompareResult==0){
                        this.billCompareResult='上升';
                    }else if(this.billCompareResult==1){
                        this.billCompareResult='下降';
                    }
                    // 上升下降比率
                    this.billCompareResultRatio = res.data.billCompareResultRatio;
                    // 年度每月花费：y轴数据
                    this.annualMonthlyExpenditure = res.data.annualMonthlyExpenditure;
                    // 年度每月花费：x轴数据
                    this.xaxisData = res.data.xaxisData;
                    this.init();
                })
            },
        	/******************图表*****************/
            //年度每月花费
            annualMonthlyExpensesLine:function(){
                this.chartAnnualMonthlyExpenses=this.$echarts.init(document.getElementById("annualMonthlyExpenses"));
                this.chartAnnualMonthlyExpenses.setOption({
                    title: {
						text: '年度每月花费',
						x: 'center',
						textStyle:{
							fontSize:13//主题文字字体大小，默认为18px
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					legend: {
						bottom: 0,
						data: ['月度花费']
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					grid: {
						left: '2%',
						right: '2%',
						bottom: '9%',
						containLabel: true,
						y2: 140
					},
					xAxis: [
						{
							type: 'category',
							boundaryGap: false,
							data: this.xaxisData,
							axisLabel: {
								interval: 0,
								rotate: 40
							},
						}
					],
					yAxis: [
						{
							type: 'value',
						}
					],
					series: [

						{
							name: '月度花费',
							type: 'line',
							stack: '总量',
							label: {
								normal: {
									show: true,
									position: 'top'
								}
							},
							areaStyle: { normal: {} },
							data: this.annualMonthlyExpenditure
						}
					]
                })
            }
        }
    }
</script>

<style scoped>
    .title
    {
        font-size:14px;
        font-weight: 600;
        float:left;
        color:#000;
        margin-bottom: 30px;
    }
	/* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
    .title
    {
        font-size:13px;
        font-weight: 600;
        float:left;
        color:#000;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/report_configuration/FinancialOptimization.vue